export const plants = [
    { label: 'Aloe Vera', value: 'Aloe Vera' },
    { label: 'Apple Tree', value: 'Apple Tree' },
    { label: 'Bamboo', value: 'Bamboo' },
    { label: 'Basil', value: 'Basil' },
    { label: 'Cactus', value: 'Cactus' },
    { label: 'Carnation', value: 'Carnation' },
    { label: 'Corn', value: 'Corn' },
    { label: 'Geranium', value: 'Geranium' },
    { label: 'Fern', value: 'Fern' },
    { label: 'Jasmine', value: 'Jasmine' },
    { label: 'Potato', value: 'Potato' },
    { label: 'Pandan', value: 'Pandan' },
    { label: 'Orchid', value: 'Orchid' },
    { label: 'Rose', value: 'Rose' },
    { label: 'Sunflower', value: 'Sunflower' },
    { label: 'Tomato', value: 'Tomato' },
]